var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPassport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10.6666H9.33341M5.86675 14.6666H10.1334C11.2535 14.6666 11.8136 14.6666 12.2414 14.4487C12.6177 14.2569 12.9237 13.951 13.1154 13.5746C13.3334 13.1468 13.3334 12.5868 13.3334 11.4666V4.53331C13.3334 3.41321 13.3334 2.85316 13.1154 2.42533C12.9237 2.04901 12.6177 1.74305 12.2414 1.5513C11.8136 1.33331 11.2535 1.33331 10.1334 1.33331H5.86675C4.74664 1.33331 4.18659 1.33331 3.75877 1.5513C3.38244 1.74305 3.07648 2.04901 2.88473 2.42533C2.66675 2.85316 2.66675 3.41321 2.66675 4.53331V11.4666C2.66675 12.5868 2.66675 13.1468 2.88473 13.5746C3.07648 13.951 3.38244 14.2569 3.75877 14.4487C4.18659 14.6666 4.74664 14.6666 5.86675 14.6666ZM10.0001 5.99998C10.0001 7.10455 9.10465 7.99998 8.00008 7.99998C6.89551 7.99998 6.00008 7.10455 6.00008 5.99998C6.00008 4.89541 6.89551 3.99998 8.00008 3.99998C9.10465 3.99998 10.0001 4.89541 10.0001 5.99998Z",
    stroke: "#CAD5E2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPassport);
export default __webpack_public_path__ + "static/media/ic_passport.3891b6e368060069eb9009dd723e29bf.svg";
export { ForwardRef as ReactComponent };